export const ZOOM_DEFAULT = 7;
export const CENTER_DEFAULT = { lat: 48.85661400000001, lng: 2.3522219000000177 };
export const RAYON_MAX = 100;
export const RAYON_MIN = 1;
export const RAYON_DEFAULT = 10;
export const RAYON_STEP = 1;

export const MAP_TYPE_CONTROL_OPTIONS = {
  mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map'],
};
export const MAP_TYPE_NAME = 'Cacher POI';

export const STYLE_MAPS_POI_HIDDEN = [
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/configurations/configurationCarto.js